import React, { useEffect, useMemo } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';

import ProductActions from '../../store/ducks/product';
import generatePallete from './palettes';
import overrides from './overrides';
import shape from './shape';
import shadows from './shadows';
import typography from './typography';
import globalStyles from './globalStyles';

const ProductTheme = props => {
  const { children } = props;
  const dispatch = useDispatch();
  const { product } = useSelector(state => state);

  useEffect(() => {
    dispatch(ProductActions.requestConfig());
  }, [dispatch]);

  const customTheme = useMemo(
    () =>
      createMuiTheme({
        palette:
          product.theme === 'DARK'
            ? generatePallete('DARK', product.colors)
            : generatePallete('LIGHT', product.colors),
        overrides,
        shape,
        shadows,
        typography,
        globalStyles,
      }),
    [product.colors, product.theme],
  );

  useEffect(() => {
    if (process.env.REACT_APP_DEBUG_THEME) {
      console.info('THEME ---->', customTheme);
    }
  }, [customTheme]);

  return <ThemeProvider theme={customTheme}>{children}</ThemeProvider>;
};

export default ProductTheme;
